module.exports = __webpack_public_path__ + "img/ni.26df812a.png";